import { FC, PropsWithChildren } from "react";
import { useWatch } from "react-hook-form";
import cn from "classnames";

import { Dropdown, TextArea } from "capitalrx-components-2.0/lib/forms";

import { QuestionWrapper, QuestionnaireWrapperProps } from "./QuestionWrapper";
import styles from "./SelectDropdown.module.scss";
import PAStyles from "../../ClinicalCriteria.module.scss";

interface Props extends QuestionnaireWrapperProps {
  readonly selectLabel: string;
  readonly selectRequired?: boolean;
  readonly otherRequired?: boolean;
  readonly placeholder?: string;
  readonly renderAnswerChoicesOnly?: boolean;
}

export const SelectDropdown: FC<PropsWithChildren<Props>> = ({
  selectLabel,
  selectRequired = false,
  name,
  children,
  disabled = false,
  placeholder = "Select an Option",
  otherRequired,
  isReadonly = false,
  renderAnswerChoicesOnly = false,
  ...rest
}) => {
  const radioValue = useWatch({ name });

  const other = radioValue === "other" || (typeof radioValue === "object" && !Array.isArray(radioValue) && radioValue?.value === "other");

  let otherTextField;
  if (other) {
    otherTextField = (
      <TextArea.Field
        testId={`${name}_other`}
        name={`${name}_other`}
        placeholder={"Enter more information"}
        required={otherRequired}
        readOnly={isReadonly}
        hideLabel
      />
    );
  }

  const choices = (
    <Dropdown.Field
      name={name}
      label={selectLabel}
      required={selectRequired}
      disabled={disabled}
      placeholder={placeholder}
      readOnly={isReadonly}
      testId={`answer_select_${name}`}
      hideLabel={!selectLabel}
      className={cn(PAStyles.FullWidth, styles["dropdown-option-max-with"])}
    >
      {children}
    </Dropdown.Field>
  );

  let component = (
    <QuestionWrapper
      disabled={disabled}
      isReadonly={isReadonly}
      name={name}
      {...rest}
    >
      {choices}
      {otherTextField}
    </QuestionWrapper>
  );

  if (renderAnswerChoicesOnly) {
    component = choices;
  }
  return <>{component}</>;
};
